import {translateI18nField} from '../core/locale';
import {ServingImage} from './shared/serving-image';

/**
 * This a variation of PejInfoLink where we reuse the same backend model for a slightly different purpose.
 */
export class PejOrderCustomData {
    descriptionI18n: {[key: string]: string};
    id: string;
    image: ServingImage;
    htmlI18n: {[key: string]: string};
    nameI18n: {[key: string]: string};
    url: string;

    public get description(): string {
        return translateI18nField(this.descriptionI18n);
    }
    public set description(ignored) {
    }

    public get html(): string {
        return translateI18nField(this.htmlI18n);
    }
    public set html(ignored) {
    }

    public get name(): string {
        return translateI18nField(this.nameI18n);
    }
    public set name(ignored) {
    }
    public get required(): boolean {
        try {
            return this.url ? JSON.parse(this.url).required : false;
        } catch (_) {
            return false;
        }
    }
    public set required(value) {
        this.url = JSON.stringify({ required: !!value })
        console.log(value, this.url)
    }
}
